import {Component, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-mentor-guide',
  templateUrl: './app-mentor-guide.component.html',
  styleUrls: ['./app-mentor-guide.component.css']
})
export class AppMentorGuideComponent implements AfterViewInit {
  @Input() pageLoaded: boolean;
  @Input() assetsRoute: string = '../assets';

  @Output() outPutMenuClick = new EventEmitter<void>();

  isShowItem = false;
  isScorm = false;

  constructor(private commonService: CommonService) {}

  ngAfterViewInit() {
    if (localStorage.getItem('source_env') === 'LMS_SCORM') {
      this.isScorm = true;
      return;
    }
    if (this.pageLoaded) {
      setTimeout(() => {
        this.isShowItem = true;
      }, 1000);
    }
  }

  clickMenu(): void {
    if (this.commonService.isMentorGuideDebugMode()) {
      this.outPutMenuClick.emit();
      return;
    }
    this.commonService.setOnceIno(this.commonService.MENTOR_GUIDE_ONCE_VALUE).subscribe(() => {
      this.outPutMenuClick.emit();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app-mentor-guide/app-mentor-guide.component.ts